<template>
  <div class="sessionsList">
    <!-- 页头 -->
    <div class="page-header-style">
      <el-page-header @back="goBack" :content="$t('lang.title_sessionsList')"></el-page-header>
    </div>
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 场次input -->
        <el-form-item :label="$t('lang.lab_sessions')">
          <input style="display: none"/>
          <el-input v-model="sessions" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_sessions')"></el-input>
        </el-form-item>
        <!-- 场馆input -->
        <el-form-item :label="$t('lang.lab_venue')">
          <input style="display: none"/>
          <el-input v-model="venue" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_venue')"></el-input>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 场次 -->
        <el-table-column prop="competeNumberName" :label="$t('lang.lab_sessions')" :sortable="'custom'"></el-table-column>
        <!-- 场馆 -->
        <el-table-column prop="venueName" :label="$t('lang.lab_venue')" :sortable="'custom'"></el-table-column>
        <!-- 比赛时间 -->
        <el-table-column prop="startTime" :label="$t('lang.lab_competeStartTime')" :sortable="'custom'">
          <template slot-scope="scope">
            {{ scope.row.startTime | time }}
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)">{{$t('lang.btn_edit')}}</el-button>
            <el-button @click="onDetail(scope.row)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="880px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="160px" label-suffix=":">
        <!-- 场次名称 -->
        <el-form-item prop="competeNumberName" :label="$t('lang.lab_sessionName')">
          <input style="display: none"/>
          <el-input v-model="form.competeNumberName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_sessionName')" maxlength="10" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 场馆 -->
        <el-form-item prop="venueName" :label="$t('lang.lab_venue')">
          <input style="display: none"/>
          <el-input v-model="form.venueName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_venue')" maxlength="20" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 地址 -->
        <el-form-item prop="detailLocation" :label="$t('lang.lab_detailLocation')">
          <input style="display: none"/>
          <el-input v-model="form.detailLocation" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_detailLocation')" maxlength="50" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 比赛时间 -->
        <el-form-item prop="startTime" :label="$t('lang.lab_raceTime')">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            value-format="timestamp"
            :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_raceTime')"
            format="yyyy-MM-dd HH:mm:ss"
            :disabled="isCase === 2"
          ></el-date-picker>
          <span class="margin-l10">{{$t('lang.lab_gm')}}</span>
        </el-form-item>
        <!-- 赛事项目(新) -->
        <el-form-item prop="competeItemIdList" ref='competeItemList' :label="$t('lang.lab_competeItem')">
          <el-form :rules="cRules" :model="form" ref="cForm">
            <el-table 
              ref="multipleTable"
              :data="form.competeItemList" 
              @selection-change="handleSelectionChangeC"
              border 
              class="table-position">
              <el-table-column type="selection" align="center" width="55"></el-table-column>
              <el-table-column prop="itemName" :label="$t('lang.lab_competeItem')" align="center"></el-table-column>
              <el-table-column prop="itemOrder" :label="$t('lang.lab_order')" align="center" width="155">
                <template slot-scope="scope">
                  <template v-if="isCase !== 2">
                    <el-form-item :prop="'competeItemList.' + scope.$index + '.itemOrder'" :rules="cRules.itemOrder">
                      <el-input @input="keyOrder(scope.$index)" v-model="scope.row.itemOrder" :placeholder="$t('lang.lab_order')" maxlength="5" :disabled="scope.row.isSelected === false"></el-input>
                    </el-form-item>
                  </template>  
                  <template v-else>
                    <span >{{ scope.row.itemOrder }}</span>
                  </template>
                </template>  
              </el-table-column>
            </el-table>
          </el-form>          
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="isCase !== 2">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form','cForm')" :disabled="isDisabled">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:sessionsList
 *@Description:场次管理
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-15
 */
export default {
  name: '',
  components: {},
  data() {
    // 排序
    var orderCheck = (rule, value, callback) => {
      console.log('orderCheck', rule.field, value)
      var str = rule.field.toString()
      str = str.replace('competeItemList.', '')
      str = str.replace('.itemOrder', '')
      let a = Number(str)
      console.log('str', str, this.form.competeItemList[a], this.form.competeItemList[a].isSelected)
      if (this.form.competeItemList[a].isSelected === false) {
        callback()
      }
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_order')))
      } else if (value < 1) {
        callback(new Error(this.$i18n.t('lang.warning_orderLow')))
      } else {
        callback()
      }
    }
    return {
      isShow: false, // 新增编辑dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑dialog的title
      isCase: 0, // 当前状态：0新增 1编辑 2查看
      /* 确定按钮可点击 */
      isDisabled: true, // 确定按钮置灰
      /* 场次管理列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      sessions: '', // 筛选-场次
      venue: '', // 筛选-场馆
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      checkAll: false, // 表示 checkbox 的全选状态
      isIndeterminate: true, // 表示 checkbox 的不确定状态
      tableData: [], // 场次管理列表数据
      /* 记忆筛选项值 */
      sessions_bak: '', // 备份-场次
      venue_bak: '', // 备份-场馆
      /* 场次管理(新建编辑查看)变量 */
      rules: {
        competeNumberName: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_sessions'), trigger: 'blur' }],
        venueName: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_venue'), trigger: 'blur' }],
        detailLocation: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_detailLocation'), trigger: 'blur' }],
        startTime: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_raceTime'), trigger: 'change' }],
        competeItemIdList: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeItem'), trigger: 'change' }],
        // competeItemList: [{ required: true, message: this.$i18n.t('lang.pla_pleaseFillin') + this.$i18n.t('lang.lab_competeItem'), trigger: 'change' }],
      },
      cRules: {
        itemOrder: [{ required: true, validator: orderCheck, trigger: 'blur' }],
      },
      competes: [], // 赛事项目list
      competeIds: [], // 赛事项目id list
      form: {
        id: '',
        competeId: '',
        competeNumberName: '',
        venueName: '',
        detailLocation: '',
        startTime: '',
        competeItemIdList: [],
        competeItemList: [],
      }, // 详细数据
      multipleSelectionC: []
    }
  },
  computed: {},
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
        console.log('isDisabled:', this.isDisabled)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取场次管理列表数据
    getData() {
      this.$get(`/competeNum/filterCompeteNum?competeId=${this.competeId}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取赛事项目checklist
    getCompeteList(id) { 
      this.$get(`/item/competeNum/item?competeId=${this.competeId}&competeNumId=${id}`).then(
        res => {
          if (res && res.code === 200) {
            console.log('getCompeteList', res.data.list)
            this.competes = []
            this.competes = res.data.list
            this.competeIds = []
            for (let index = 0; index < this.competes.length; index++) {
              this.competeIds.push(this.competes[index].id)
              if (this.competes[index].isSelected === true) {
                this.form.competeItemIdList.push(this.competes[index].id)
                this.$nextTick(() => {
                  this.$refs.multipleTable.toggleRowSelection(this.competes[index], true)
                })
               }
              this.form.competeItemList.push(this.competes[index])
            }
            this.handleCheckedCompeteChange(this.form.competeItemIdList)
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.saveData = JSON.stringify(this.form)
            this.isShow = true
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.sessions_bak = this.sessions
        this.venue_bak = this.venue
      } else { 
        // 筛选项正确显示
        this.sessions = this.sessions_bak
        this.venue = this.venue_bak
      }
      this.$get(`/competeNum/filterCompeteNum?competeId=${this.competeId}&competeNum=${this.sessions}&venue=${this.venue}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 重置
    onClear() {
      this.sessions = ''
      this.venue = ''
      this.sessions_bak = ''
      this.venue_bak = ''
      this.sortName = ''
      this.sortFieldName = ''
      this.pageNum = 1
      this.getData()
    },
    // 新增
    onAdd() {
      console.log('onAdd')
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.isCase = 0
      this.checkAll = false
      this.isIndeterminate = false
      this.form.id = ''
      this.form.competeId = this.competeId
      this.form.competeNumberName = ''
      this.form.venueName = ''
      this.form.detailLocation = ''
      this.form.startTime = ''
      this.form.competeItemIdList = []
      this.form.competeItemList = []
      this.getCompeteList(this.form.id)
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/competeNum/competeNum/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 编辑
    onEdit(data) {
      console.log('onEdit', data)
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.isCase = 1
      this.form.id = data.id
      this.form.competeId = this.competeId
      this.form.competeNumberName = data.competeNumberName
      this.form.venueName = data.venueName
      this.form.detailLocation = data.detailLocation
      this.form.startTime = data.startTime
      this.form.competeItemIdList = []
      this.form.competeItemList = []
      this.getCompeteList(this.form.id)
    },
    // 查看
    onDetail(data) {
      console.log('onDetail', data)
      this.isTitle = this.$i18n.t('lang.btn_detail')
      this.isCase = 2
      this.form.id = data.id
      this.form.competeId = this.competeId
      this.form.competeNumberName = data.competeNumberName
      this.form.venueName = data.venueName
      this.form.detailLocation = data.detailLocation
      this.form.startTime = data.startTime
      this.form.competeItemIdList = []
      this.form.competeItemList = []
      this.getCompeteList(this.form.id)
    },
  // 保存
    toSave(formName, cFormName) {
      console.log('toSave')
      this.$refs[formName].validate((valid) => {
        if (valid) {
            this.$refs[cFormName].validate((valid) => {
              if (valid) {
                let params = this.form
                this.$postJson('/competeNum/competeNum', params).then(
                  res => {
                    if (res && res.code === 200) {
                      this.$message({
                        type: 'success',
                        message: this.$i18n.t('lang.lab_modifySuccess')
                      })
                      this.handleDialogClosed()
                      // 更新列表
                      this.onSearch(true, false)
                    } else {
                      this.$message.error(res.message)
                    }
                  },
                  error => {
                    this.$message.error(error)
                  }
                )
              } else {
                return false
              }
            }) 
        } else {
          this.$refs[cFormName].validate((valid) => {
            if (valid) {
            } else {
              return false
            }
          }) 
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      this.checkAll = false
      this.isIndeterminate = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.competeId = ''
      this.form.competeNumberName = ''
      this.form.venueName = ''
      this.form.detailLocation = ''
      this.form.startTime = ''
      this.form.competeItemIdList = []
    },
    // 监听关闭'新建编辑'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.checkAll = false
      this.isIndeterminate = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.competeId = ''
      this.form.competeNumberName = ''
      this.form.venueName = ''
      this.form.detailLocation = ''
      this.form.startTime = ''
      this.form.competeItemIdList = []
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 多选框
    handleSelectionChangeC(val) {
      if (val.length === 0) {
        this.form.competeItemList.forEach((v, i) => {
          v.isSelected = false
          this.form.competeItemIdList = []
        })        
      } else {
          this.form.competeItemIdList = val ? this.competeIds : []
          this.form.competeItemList.forEach((v, i) => {
            v.isSelected = false
            val.forEach((val, index) => {
              if (val.id == v.id) {
                v.isSelected = true
                val.isSelected = true
              }
            })
            if (v.isSelected === false) {
              this.$refs.cForm.clearValidate()
            }
          })
      }
      this.multipleSelectionC = val
    },
    // 赛事项目-排序 输入限制
    keyOrder(v) {
      // 当前输入框
      console.log('keyOrder', v, this.form.competeItemList[v].itemOrder)
      // 仅保留数字和"."
      this.form.competeItemList[v].itemOrder = this.form.competeItemList[v].itemOrder.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.competeItemList[v].itemOrder.indexOf('.') < 0 && this.form.competeItemList[v].itemOrder !== '') { 
        this.form.competeItemList[v].itemOrder = parseFloat(this.form.competeItemList[v].itemOrder)
      }
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },
    // 详情-赛事项目全选
    handleCheckAllChange(val) {
      this.form.competeItemIdList = val ? this.competeIds : []
      this.isIndeterminate = false
    },
    // 详情-赛事项目半选
    handleCheckedCompeteChange(value) {
      if (value) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.competeIds.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.competeIds.length
        console.log('handleCheckedCompeteChange', value.length, this.checkAll, this.isIndeterminate)
      }
    },
    // 返回
    goBack() {
      window.history.go(-1)
    }
  },
  created() {
    this.competeId = this.$route.query.id
    if (this.competeId !== '') {
      this.getData()
    }
  },
  mounted() {}
}
</script>

<style lang='scss'>
.sessionsList{
  .margin-l10 {
    margin-left: 10px;
  }
  .table-position{
    .el-table__header {
      width: 100% !important;
    }
    .el-table__empty-block {
      width: 100% !important;
    }
    .el-table__body {
      width: 100% !important;
    }
  }
}
</style>
